'use client'

import React, { createContext, useContext } from 'react'

import type { ThemeContextType } from './types'

const initialContext: ThemeContextType = {
  setTheme: () => null,
  theme: 'light',
}

const ThemeContext = createContext(initialContext)

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  // const [theme, setThemeState] = useState<Theme | undefined>(
  //   canUseDOM ? (document.documentElement.getAttribute('data-theme') as Theme) : undefined,
  // )
  //
  // const setTheme = useCallback((themeToSet: Theme | null) => {
  //   if (themeToSet === null) {
  //     window.localStorage.removeItem(themeLocalStorageKey)
  //     const implicitPreference = getImplicitPreference()
  //     document.documentElement.setAttribute('data-theme', implicitPreference || '')
  //     if (implicitPreference) setThemeState(implicitPreference)
  //   } else {
  //     setThemeState(themeToSet)
  //     window.localStorage.setItem(themeLocalStorageKey, themeToSet)
  //     document.documentElement.setAttribute('data-theme', themeToSet)
  //   }
  // }, [])
  //
  // useEffect(() => {
  //   let themeToSet: Theme = defaultTheme
  //   const preference = window.localStorage.getItem(themeLocalStorageKey)
  //
  //   if (themeIsValid(preference)) {
  //     themeToSet = preference
  //   } else {
  //     const implicitPreference = getImplicitPreference()
  //
  //     if (implicitPreference) {
  //       themeToSet = implicitPreference
  //     }
  //   }
  //
  //   document.documentElement.setAttribute('data-theme', themeToSet)
  //   setThemeState(themeToSet)
  // }, [])

  return <ThemeContext.Provider value={{ ...initialContext }}>{children}</ThemeContext.Provider>
}

export const useTheme = (): ThemeContextType => useContext(ThemeContext)
